import * as React from 'react';

// tslint:disable:max-line-length
export const TheaterIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M15 14V8h-2v6h-2V8H9v6H7V8H5v6H3V8H1v6H0v2h16v-2zM15.4 3.1l-7-3c-.3-.1-.5-.1-.8 0l-7 3c-.4.1-.6.5-.6.9v2c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V4c0-.4-.2-.8-.6-.9zM8 5c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z" />
    </g>
  </svg>
);
